import tableIcons from 'utils/icons/materialTableIcons';

export default {
  disabled: true,
  icon: tableIcons.NoIcon,
  render: () => {
  }
};
